/*
  Pfand-Automatik fuer i&M Bauzentrum Toennes
  --------------------------------------------
  Haelt im Warenkorb je pfandpflichtigem Getraenk eine eigene Pfandposition
  synchron. Das Pfand bleibt dadurch eine EIGENE Position und wird nicht in
  den Warenpreis eingerechnet - so verlangt es die PAngV (Pfandbetrag
  getrennt ausweisen, keinen Gesamtbetrag bilden).

  Jede Pfandzeile traegt die versteckte Eigenschaft _zu mit der Variant-ID
  des Getraenks, auf das sie sich bezieht. Dadurch
    - bleiben mehrere Getraenke mit gleichem Pfandsatz getrennt,
    - laesst sich die Pfandzeile beim Rendern direkt hinter ihr Getraenk
      einsortieren (Shopify selbst kennt keine Sortierung der Zeilen und
      haengt neue Positionen oben an).
  Eigenschaften mit fuehrendem _ werden vom Theme nicht angezeigt.

  Konfiguration: window.PfandKonfig aus snippets/head-scripts.liquid.
*/
(function () {
  'use strict';

  var CFG = window.PfandKonfig;
  if (!CFG || !CFG.pfandVarianten) return;

  var zuordnung = CFG.zuordnung || {};
  var pfandIds = [];
  Object.keys(CFG.pfandVarianten).forEach(function (betrag) {
    pfandIds.push(CFG.pfandVarianten[betrag]);
  });

  var laeuft = false;          // eigener Schreibvorgang laeuft
  var abgleichTimer = null;
  var nachTimer = null;
  var letzterWarenkorb = null;

  function variantId(item) { return item.variant_id || item.id; }
  function istPfand(item) { return pfandIds.indexOf(variantId(item)) !== -1; }
  function bezugVon(item) {
    return (item.properties && item.properties._zu) ? String(item.properties._zu) : '';
  }

  function json(url, daten) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(daten)
    }).then(function (r) { return r.json(); });
  }

  function warenkorbLesen() {
    return fetch(CFG.routen.cart + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Abgleich ---------- */

  function abgleichen() {
    if (laeuft) return Promise.resolve();
    return warenkorbLesen().then(function (cart) {
      letzterWarenkorb = cart;

      var soll = {};       // "<pfandVariante>|<getraenkVariante>" -> Menge
      var vorhanden = {};  // gleicher Schluessel -> { key, menge }

      cart.items.forEach(function (item) {
        if (istPfand(item)) {
          vorhanden[variantId(item) + '|' + bezugVon(item)] = {
            key: item.key, menge: item.quantity
          };
          return;
        }
        var betrag = zuordnung[variantId(item)];
        if (!betrag) return;
        var pfandVariante = CFG.pfandVarianten[betrag];
        if (!pfandVariante) return;
        var schluessel = pfandVariante + '|' + variantId(item);
        soll[schluessel] = (soll[schluessel] || 0) + item.quantity;
      });

      var aenderungen = [];
      Object.keys(soll).forEach(function (schluessel) {
        var da = vorhanden[schluessel];
        if (!da) {
          var teile = schluessel.split('|');
          aenderungen.push({
            typ: 'add',
            variante: parseInt(teile[0], 10),
            zu: teile[1],
            menge: soll[schluessel]
          });
        } else if (da.menge !== soll[schluessel]) {
          aenderungen.push({ typ: 'change', key: da.key, menge: soll[schluessel] });
        }
      });
      // Pfandzeilen ohne zugehoeriges Getraenk verschwinden wieder.
      Object.keys(vorhanden).forEach(function (schluessel) {
        if (!soll[schluessel]) {
          aenderungen.push({ typ: 'change', key: vorhanden[schluessel].key, menge: 0 });
        }
      });

      if (!aenderungen.length) { nachbereiten(); return; }

      laeuft = true;
      return ausfuehren(aenderungen)
        .then(function () { laeuft = false; neuZeichnen(); return warenkorbLesen(); })
        .then(function (cart2) {
          letzterWarenkorb = cart2;
          planeNachbereitung();
        })
        .catch(function (e) {
          laeuft = false;
          console.warn('[Pfand] Aktualisierung fehlgeschlagen:', e);
        });
    }).catch(function (e) {
      console.warn('[Pfand] Abgleich fehlgeschlagen:', e);
    });
  }

  // Nacheinander, nicht parallel - die Cart-API vertraegt keine
  // gleichzeitigen Schreibzugriffe.
  function ausfuehren(liste) {
    return liste.reduce(function (kette, a) {
      return kette.then(function () {
        if (a.typ === 'change') {
          return json(CFG.routen.change, { id: a.key, quantity: a.menge });
        }
        return json(CFG.routen.add, {
          items: [{ id: a.variante, quantity: a.menge, properties: { _zu: a.zu } }]
        });
      });
    }, Promise.resolve());
  }

  function planen() {
    clearTimeout(abgleichTimer);
    abgleichTimer = setTimeout(abgleichen, 120);
  }

  /* ---------- Darstellung ---------- */

  // Das Theme rendert Warenkorbseite und Mini-Warenkorb ueber den
  // sections-Parameter neu; updateSectionContents() ist der vorgesehene Hebel.
  function neuZeichnen() {
    try {
      if (window.miniCart && typeof window.miniCart.updateSectionContents === 'function') {
        window.miniCart.updateSectionContents();
      }
      // CartItems.getSectionsToRender() greift ungeschuetzt auf diese IDs zu -
      // ausserhalb der Warenkorbseite wuerde das eine Ausnahme werfen.
      var seite = document.querySelector('cart-items');
      if (seite && typeof seite.updateSectionContents === 'function' &&
          document.getElementById('main-cart-items') &&
          document.getElementById('cart-page-title-wrap') &&
          document.getElementById('main-cart-footer')) {
        seite.updateSectionContents();
      }
    } catch (e) {
      console.warn('[Pfand] Neuzeichnen fehlgeschlagen:', e);
    }
  }

  var PRAEFIXE = ['#CartItem-', '#MiniCartItem-'];

  // Zeilen-IDs des Themes sind 1-basiert und folgen der Reihenfolge in
  // cart.items. data-index bleibt beim Verschieben erhalten, deshalb ist das
  // Umhaengen im DOM gefahrlos - das Theme adressiert ueber das Attribut,
  // nicht ueber die Position.
  function einsortieren(cart) {
    var zeileVonGetraenk = {};
    cart.items.forEach(function (item, i) {
      if (!istPfand(item)) zeileVonGetraenk[variantId(item)] = i + 1;
    });
    cart.items.forEach(function (item, i) {
      if (!istPfand(item)) return;
      var ziel = zeileVonGetraenk[bezugVon(item)];
      if (!ziel) return;
      PRAEFIXE.forEach(function (praefix) {
        var pfandZeile = document.querySelector(praefix + (i + 1));
        var getraenkZeile = document.querySelector(praefix + ziel);
        if (!pfandZeile || !getraenkZeile || pfandZeile === getraenkZeile) return;
        if (getraenkZeile.nextElementSibling === pfandZeile) return;
        getraenkZeile.parentNode.insertBefore(pfandZeile, getraenkZeile.nextSibling);
      });
    });
  }

  // Bei der Pfandzeile ist die Menge nicht frei waehlbar - sie ergibt sich
  // zwingend aus dem Getraenk.
  function steuerungAusblenden(cart) {
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-pfand-zeile'),
      function (el) { el.classList.remove('js-pfand-zeile'); }
    );
    cart.items.forEach(function (item, i) {
      if (!istPfand(item)) return;
      PRAEFIXE.forEach(function (praefix) {
        var zeile = document.querySelector(praefix + (i + 1));
        if (zeile) zeile.classList.add('js-pfand-zeile');
      });
    });
  }

  function nachbereiten() {
    if (!letzterWarenkorb || !letzterWarenkorb.items) return;
    try {
      steuerungAusblenden(letzterWarenkorb);
      einsortieren(letzterWarenkorb);
    } catch (e) {
      console.warn('[Pfand] Darstellung fehlgeschlagen:', e);
    }
  }

  function planeNachbereitung() {
    clearTimeout(nachTimer);
    nachTimer = setTimeout(nachbereiten, 80);
  }

  function stilEinfuegen() {
    var stil = document.createElement('style');
    stil.textContent =
      '.js-pfand-zeile .quantity-input-button,' +
      '.js-pfand-zeile cart-remove-button{display:none !important}' +
      '.js-pfand-zeile .quantity-input{border:0;background:none}' +
      '.js-pfand-zeile .quantity-input-field{pointer-events:none;background:transparent;' +
      'border:0;text-align:center;width:3ch}';
    document.head.appendChild(stil);
  }

  /* ---------- Ausloeser ---------- */

  function verdrahten() {
    // 1. Pub-Sub des Themes (product-form.js, CartItems.updateQuantity)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      [
        PUB_SUB_EVENTS.cartItemAdd,
        PUB_SUB_EVENTS.cartItemQuantityUpdate,
        PUB_SUB_EVENTS.cartItemRemove,
        PUB_SUB_EVENTS.cartUpdate
      ].forEach(function (ereignis) { if (ereignis) subscribe(ereignis, planen); });
    }

    // 2. Aufsatz auf fetch - erfasst auch Theme-Teile und Apps ohne Ereignis
    var originalFetch = window.fetch;
    window.fetch = function (eingabe) {
      var url = (typeof eingabe === 'string') ? eingabe : (eingabe && eingabe.url) || '';
      var schreibt = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
      var antwort = originalFetch.apply(this, arguments);
      if (schreibt && !laeuft) {
        antwort.then(function () { planen(); }).catch(function () {});
      }
      return antwort;
    };

    // 3. Das Theme ersetzt beim Neuzeichnen ganze Abschnitte per innerHTML.
    //    Danach muss erneut einsortiert und ausgeblendet werden.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (letzterWarenkorb) planeNachbereitung();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function start() {
    stilEinfuegen();
    verdrahten();
    abgleichen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
